import React from 'react';
import HeadHero from '../Head/headhero.jsx';
import Header from "../Header.jsx";

class Payment extends React.Component{

    render(){
        return(
            <React.Fragment>
                <Header />
                <HeadHero head_2={"PAYMENT"} head_3={"IBAN"} />
                <ul className='payment--methods'>
                    <li>
                        <span>Eurobank</span>
                        <p>GR4402600350000120200949882</p>
                        <h2>KONST BAKATSELOS</h2>
                    </li>
                    <li>
                        <span>National Bank of Greece</span>
                        <p>GR9801106680000066800198286</p>
                        <h2>KONSTANTINOS BAKATSELOS</h2>
                    </li>
                    <li>
                        <span>Alpha Bank</span>
                        <p>GR3201401180118002310044496</p>
                        <h2>KONSTANTINOS BAKATSELOS</h2>
                    </li>
                    <li>
                        <span>Piraeus Bank</span>
                        <p>GR7501721800005180108639772</p>
                        <h2>KONSTANTINOS BAKATSELOS</h2>
                    </li>
                </ul>
            </React.Fragment>

        );
    }


}

export default Payment;